import { useState, useEffect } from 'react'
import { Box, Card, Grid } from '@mui/material'
import { CardButton } from '../../components/buttons'
import './style.css'
import { useNavigate } from 'react-router-dom'
import { useAuth, useTimeContext, useUser } from '../../context'
import { useNotificationsContext } from '../../context/Notifications.context'
import { useStatus } from '../../context/Status.context'
import { ROLES } from '../../config'
import { logsDatabase } from '../../indexedDB'

const WelcomePage = () => {
    const { userData } = useAuth()
    const {
        admin,
        isOperator,
        isSapExecutive,
        isShiftManager,
        isChiefMachinery,
        isUniversalInspector,
        isUniversalChief,
        isOperatorInspector,
        isObserver
    } = useUser()
    const { date, hour } = useTimeContext()
    const { myNotifications, lastNotification, ultimaNoticia, noticias, listaLectura } = useNotificationsContext()
    const { setstatus } = useStatus()
    const [disableButtonNoSAP, setDisableButtonsNoSAP] = useState(true)
    const [disableButtonNoAdmin, setDisableButtonNoAdmin] = useState(true)

    useEffect(() => {
        if (admin || isSapExecutive || isShiftManager || isChiefMachinery || isOperatorInspector || isUniversalChief || isObserver || isUniversalInspector) {
            setDisableButtonsNoSAP(false)
        }
        if (admin) {
            setDisableButtonNoAdmin(false)
        }
    }, [admin, isOperator, isSapExecutive, isShiftManager, isChiefMachinery, isOperatorInspector, isUniversalChief, isObserver, isUniversalInspector])

    const navigate = useNavigate()

    const unreadNotifications = myNotifications.filter(n => !n.isResolved)
    const unreadNews = noticias.filter(n => !n.isRead && n.state !== false)

    const isUniversal = isUniversalInspector || isUniversalChief

    const shouldShowCard = (variant) => {
        if (variant === 'calendar') return true

        if (variant === 'assignment' && admin) {
            return false
        }

        if (admin) return true

        const isRegularOperator = isOperator && !isUniversalInspector && !isOperatorInspector && !isUniversalChief

        if (isRegularOperator) {
            return variant === 'assignment'
        }

        // Executive / special operator
        const isSpecialUserForAssignments = isUniversalInspector || isOperatorInspector

        if (variant === 'assignment') {
            return isSpecialUserForAssignments
        }

        if (variant === 'administration') {
            return false // only admins see administration
        }

        // For machines, reports
        return ['machines', 'reports'].includes(variant)
    }

    const getCounter = (list) => {
        if (list.length <= 1) return ''
        const count = list.length - 1
        return count > 9 ? '+9' : `+${count}`
    }

    const getGridSizes = () => {
        const visibleCount = ['assignment', 'machines', 'reports', 'administration'].filter(shouldShowCard).length
        if (visibleCount === 1) {
            return { xs: 12, sm: 12, md: 12, lg: 12 }
        }
        if (visibleCount === 2) {
            return { xs: 12, sm: 6, md: 6, lg: 6 }
        }
        if (visibleCount === 3) {
            return { xs: 12, sm: 4, md: 4, lg: 4 }
        }
        return { xs: 12, sm: 6, md: 3, lg: 3 }
    }

    return (
        <Box height='100%'>
            <Grid className={'root'} container spacing={0}>
                <Grid className={'pageContainer'} item xs={12}>
                    {userData && <Card elevation={0} className={'pageCard'} sx={{ maxHeight: 'calc(100vh - 100px)', overflowY: 'auto' }}>
                        <div>
                            <p className='titulo'>Hola {userData.name} ¿Por dónde quieres comenzar hoy?</p>
                        </div>
                        <Grid container spacing={5}>
                            <Grid item xs={12} sm={12} md={12} lg={shouldShowCard('calendar') ? 9 : 12}>
                                <Grid container spacing={5}>
                                    <Grid item xs={12} sm={12} md={6} lg={4}>
                                        <div className='notificaciones reloj'>
                                            <p className='reloj-fecha'> {date} </p>
                                            <p className='reloj-hora'> {hour} hrs </p>
                                        </div>
                                    </Grid>
                                    <Grid item xs={12} sm={12} md={6} lg={4}>
                                        <button className={`notificaciones alertas ${unreadNotifications.length > 0 ? 'destacado' : ''}`} onClick={() => navigate('/notifications')}>
                                            <div style={{ position: 'relative', width: '100%', height: '100%', display: 'flex', flexDirection: 'column', justifyContent: unreadNotifications.length > 0 ? 'flex-start' : 'center' }}>
                                                <p className='notificaciones-label' style={unreadNotifications.length === 0 ? { fontSize: '1.2vw', textAlign: 'center', margin: 0 } : {}}>
                                                    Notificaciones
                                                </p>
                                                {unreadNotifications.length > 0 && (
                                                    <p className='notificaciones-texto'>
                                                        {unreadNotifications[0].title || unreadNotifications[0].message}
                                                    </p>
                                                )}
                                                {unreadNotifications.length > 1 && (
                                                    <span className="badge-counter">{getCounter(unreadNotifications)}</span>
                                                )}
                                            </div>
                                        </button>
                                    </Grid>
                                    <Grid item xs={12} sm={12} md={6} lg={4}>
                                        <button className={`notificaciones alertas ${unreadNews.length > 0 ? 'destacado' : ''}`} onClick={() => navigate(admin ? '/news' : '/mynews')}>
                                            <div style={{ position: 'relative', width: '100%', height: '100%', display: 'flex', flexDirection: 'column', justifyContent: unreadNews.length > 0 ? 'flex-start' : 'center' }}>
                                                <p className='notificaciones-label' style={unreadNews.length === 0 ? { fontSize: '1.2vw', textAlign: 'center', margin: 0 } : {}}>
                                                    Noticias internas
                                                </p>
                                                {unreadNews.length > 0 && (
                                                    <p className='notificaciones-texto'>
                                                        {unreadNews[0].title || unreadNews[0].titulo}
                                                    </p>
                                                )}
                                                {unreadNews.length > 1 && (
                                                    <span className="badge-counter">{getCounter(unreadNews)}</span>
                                                )}
                                            </div>
                                        </button>
                                    </Grid>
                                </Grid>
                                <br />
                                <Grid container spacing={5}>
                                    {shouldShowCard('assignment') && (
                                        <Grid item {...getGridSizes()}>
                                            <CardButton variant='assignment' disableButton={false}/>
                                        </Grid>
                                    )}
                                    {shouldShowCard('machines') && (
                                        <Grid item {...getGridSizes()}>
                                            <CardButton variant='machines' disableButton={false}/>
                                        </Grid>
                                    )}
                                    {shouldShowCard('reports') && (
                                        <Grid item {...getGridSizes()}>
                                            <CardButton variant='reports' disableButton={false}/>
                                        </Grid>
                                    )}
                                    {shouldShowCard('administration') && (
                                        <Grid item {...getGridSizes()}>
                                            <CardButton variant='administration' disableButton={false}/>
                                        </Grid>
                                    )}
                                </Grid>
                            </Grid>
                            {shouldShowCard('calendar') && (
                                <Grid item xs={12} sm={12} md={12} lg={3}>
                                    <Grid container /* spacing={5} */ style={{ height: '100%' }}>
                                        <Grid item xs={12} sm={12} md={12} lg={12}>
                                            <CardButton variant='calendar' disableButton={false}/>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            )}
                        </Grid>
                    </Card>}
                </Grid>
            </Grid>
        </Box>
    )
}

export default WelcomePage
